import {
  replaceMessageValue,
  resolveTranslatedMessage,
} from './resolve-translated-message';
import {MessageDescriptor} from '@ui/i18n/message-descriptor';
import {useSelectedLocale} from '@ui/i18n/selected-locale';
import {shallowEqual} from '@ui/utils/shallow-equal';
import memoize from 'nano-memoize';
import {useCallback} from 'react';

export interface UseTransReturn {
  trans: (props: MessageDescriptor) => string;
}

export function useTrans(): UseTransReturn {
  const {lines, localeCode} = useSelectedLocale();
  const trans = useCallback(
    (props: MessageDescriptor): string => {
      return translate({...props, lines, localeCode});
    },
    [lines, localeCode],
  );

  return {trans};
}

interface TranslateProps extends MessageDescriptor {
  lines?: Record<string, string>;
  localeCode: string;
}
const translate = memoize(
  (props: TranslateProps) => {
    let {lines, message, values, localeCode} = props;

    if (message == null) {
      return '';
    }

    message = resolveTranslatedMessage(props, lines, localeCode);

    if (!values) {
      return message;
    }

    Object.entries(values)
      .sort(([a], [b]) => b.length - a.length)
      .forEach(([key, value]) => {
        message = replaceMessageValue(message, key, value);
      });

    return message;
  },
  {equals: shallowEqual},
);
